<template>
  <a-modal :title="title" v-model="visible" @ok="handleOk" class="preserve-model">
    <div class="preserve-image">
      <img src="@/assets/image/chenggong.png" alt="成功" class="image">
      <span>{{ content }}</span>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'preserveModal',
  data () {
    return {
      title: '保存提交',
      content: '您是否确认提交此单？',
      visible: false,
      typeId:null
    }
  },
  methods: {
    show (data) {
      this.visible = true
      this.typeId = data.id
      this.title = data ? data.title : '保存提交'
      this.content = data ? data.content : '您是否确认提交此单？'
    },
    cancel () {
      this.visible = false
    },
    handleOk () {
      this.visible = false
      this.$emit('handleOk', this.typeId)
    }
  }
}
</script>
<style lang="scss">
.preserve-model {
  width: 520px !important;
  .ant-modal-content {
    height: 250px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 100px;
      display: flex;
      //   align-items: center;
      justify-content: center;
      padding: 30px 0 0 0;
    }
    .ant-btn {
      width: 148px;
      border-radius: 6px !important;
    }

    .preserve-image {
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      .image {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }
    }
  }
  .ant-modal-footer{
      padding-bottom:40px;
  }
}
</style>
